<template>
	<span class="counter">{{ currentCount }}</span>
</template>

<script>
export default {
	name: "CounterAni",
	props: {
		target: {
			type: Number,
			required: true
		},
		duration: {
			type: Number,
			default: 1000
		}
	},
	data() {
		return {
			currentCount: 0
		};
	},
	mounted() {
		this.startCounting();
	},
	methods: {
		startCounting() {
			let stepTime = Math.abs(Math.floor(this.duration / this.target));
			if(stepTime == 'Infinity'){
				stepTime = 1
			}
			let currentCount = 0;

			const interval = setInterval(() => {
				
				if (currentCount < this.target) {
					if(stepTime > 1){
						currentCount++;
					} else {
						currentCount = currentCount + 10;
					}
					this.currentCount = currentCount;
				} else {
					clearInterval(interval);
				}
			}, stepTime);
		},
		updateCounting() {
			this.startCounting();
		}
	},
	watch: {
		target() {
			this.updateCounting();
		},
	}
};
</script>

<style scoped>
.counter {
	transition: color 0.3s ease;
}
</style>
